import COLLABORATIVE_PHYSICIANS_QUERY from '../queries/collaborating_physicians.graphql';
import { apolloClient } from "@td/ui";
import { mapToProviderToDropdownOption } from '../utils';

const queryCollaboratingPhysicians = async (state) => {
  const { data: { providerBasicSearch: { edges } } } = await apolloClient.query({
    query: COLLABORATIVE_PHYSICIANS_QUERY,
    fetchPolicy: "network-only",
    variables: {
      params: {
        stateCd: state,
        isSupervisor: true,
      }
    }
  });

  return edges.map(({node}) => mapToProviderToDropdownOption(node));
}

export default queryCollaboratingPhysicians;
